// extracted by mini-css-extract-plugin
export default {"section":"FunnelsPage_section__wvb7F","funnelRow":"FunnelsPage_funnelRow__EXJTT","failureGrid":"FunnelsPage_failureGrid__k6yOg"};